import { UrlConstants } from "./../../models/urlConstants";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import {
  AsyncValidatorFn,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { CreateUserObj, ResetPassObj } from "src/app/models/login";
import { AccountService } from "src/app/services/account.service";
import Swal from "sweetalert2";
import { CustomValidators } from "../forget-password/custom-validators";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./create-user.component.html",
  styleUrls: ["./create-user.component.scss"],
})
export class CreateUserComponent implements OnInit {
  createUserObj: CreateUserObj = {} as CreateUserObj;
  resetPassWordForm: FormGroup;
  passwordStepper: any;
  showPassword1: boolean = false;
  showPassword2: boolean = false;
  otp;
  lang: string;
  isDuplicateUserName: boolean;

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private _Activatedroute: ActivatedRoute,
    private router: Router,
    private accService: AccountService,
    private apiService: ApiService
  ) {
    this._Activatedroute.queryParams.subscribe((params) => {
      this.createUserObj.Otp = params["otp"];
    });
  }

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.passwordStepper = 1;
    this.resetPassWordForm = new FormGroup(
      {
        userName : new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.pattern(/^[a-zA-Z1-9]+$/)  // Regex to allow only a-z and 1-9
          ])
        ),
        firstNewPassword: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true,
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true,
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true,
              }
            ),
            Validators.minLength(8),
          ])
        ),
        reFirstNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
        secondNewPassword: new FormControl(
          null,
          Validators.compose([
            // check whether the entered password numbers Only

            Validators.required,
            Validators.pattern("^[0-9]{6}$"),
          ])
        ),
        reSecondNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
      },
      [
        CustomValidators.firstPasswordMatchValidator as AsyncValidatorFn,
        CustomValidators.secondPasswordMatchValidator as AsyncValidatorFn,
      ]
    );
  }

  onSubmit() {
    this.createUserObj.Username = this.resetPassWordForm.value.userName.toLowerCase();
    this.createUserObj.Password = this.resetPassWordForm.value.firstNewPassword;
    this.createUserObj.SecondPassword =
      this.resetPassWordForm.value.secondNewPassword;
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.accService.create(this.createUserObj).subscribe(
          (arg) => {
            if (arg == true) {
              this.router.navigate(["/login"]);
              Swal.fire({
                position: "center",
                icon: "success",
                title:
                  this.translate.instant("create-user-success-msg") +
                  UrlConstants.supportNumber,
                showConfirmButton: false,
                timer: 4500,
              });
            }
            if (arg == false) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("create-user-err-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          },
          (err) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: this.translate.instant("pass-error-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
          }
        );
      });
  }
  removeErrorMsg(){
    if(this.resetPassWordForm.value.userName == ''){
      this.isDuplicateUserName=false
    }
  }
  next() {
    this.apiService.checkUserNameAvailability(this.resetPassWordForm.value.userName.toLowerCase())
    .subscribe(
      (res: boolean)=>{
        if(!res){
          this.isDuplicateUserName=true
        } else {
          this.isDuplicateUserName=false
          this.showPassword1 = false;
          this.showPassword2 = false;
          this.passwordStepper = this.passwordStepper + 1;
        }
      }
    )
  }
  back() {
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.passwordStepper = this.passwordStepper - 1;
  }
}
